import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/seclgroup.webp';
import screenshot_target from '../../../images/letterfunnel/mykytasemenov.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Mykyta Semenov"
      firstname="Mykyta"
      companyname="SECL Group"
      competition="N-iX en Eleks"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/mykytasemenov.js